import type { ListBuilderList } from '../../../types';
import {
	AGING_REQUIRED_FIELDS,
	BASE_FILTER_RULES,
	INVOICE_MOBILE_CARD_CONFIG,
} from '../shared';

/**
 * Past due 90+ days - outstanding invoices more than 90 days past due
 */
export const pastDue90PlusList: ListBuilderList = {
	id: 'default-invoices-past-due-90-plus',
	inheritsFrom: 'default-invoices-all',
	cacheTTL: 600000,
	name: 'Past Due 90+',
	type: 'default',
	active: true,
	sortOrder: 6,
	description: 'Outstanding invoices more than 90 days past due',
	defaultSortId: 'date-asc',
	requiredFields: AGING_REQUIRED_FIELDS,
	filterRules: {
		...BASE_FILTER_RULES,
		invoicePaymentStatus: {
			defaultValue: [{ id: 'outstanding', label: 'Outstanding' }],
		},
		invoiceDueDateRange: {
			defaultValue: [
				{
					id: 'past-due-90-plus',
					label: '90+ Days Past Due',
					data: {
						endDate: '{{DATE:-91d}}',
					},
				},
			],
		},
		// Clear the default 90-day invoice date filter so all matching invoices show
		invoiceDateRange: {
			defaultValue: [],
		},
	},
	mobileCardConfig: INVOICE_MOBILE_CARD_CONFIG,
};
